import { DataGridTypes } from 'devextreme-react/data-grid';

import FieldColorHelper from '../../tools/FieldColorHelper';

const DataTypeCell = (cellData: DataGridTypes.ColumnCellTemplateData) => {
    let tagColor = FieldColorHelper.GetTagColor(cellData.value.Type);
    let textColor = FieldColorHelper.GetTextColor(cellData.value.Type);

    return (
        <div style={{ width: 'auto', height: 22, paddingLeft: 10, paddingRight: 10, paddingTop: 2, paddingBottom: 2, background: tagColor, borderRadius: 16, justifyContent: 'center', alignItems: 'center', gap: 6, display: 'inline-flex' }}>
            <div style={{ textAlign: 'center', color: textColor, fontSize: 10, fontFamily: 'Manrope', fontWeight: '500', textTransform: 'uppercase', letterSpacing: 1, wordWrap: 'break-word' }}>{cellData.value.Label}</div>
        </div>
    )
};

export default DataTypeCell;
